import { Observable } from "rxjs";
import { DefaultMail, Issue, IssueAuditStatus, IssueAuditWrapper, IssueTransaction } from "./classes";
import { InjectionToken } from '@angular/core';
import { ChangeCollisionEntry } from "../shared/classes";
import { Step } from "./components/dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes";
import { FormGroup } from "@angular/forms";
import { DefaultNotification } from "../default-notification/classes";

export interface IIssueTransactionView { }

export interface ITransactionSummaryView { }

export const ISSUE_PROVIDER_SERVICE = new InjectionToken<IIssueProviderService>('ISSUE_PROVIDER_SERVICE');

export interface IIssueProviderService {
    issueId$: Observable<number>;
    issueState$: Observable<number>;
    issue$: Observable<Issue>;
    formGroup?: FormGroup;
    getCurrentIssueType(): Observable<number>;
    updateIssue(issue: Issue): void;
}

export const ISSUE_TYPE_PROVIDER_SERVICE = new InjectionToken<IIssueProviderService>('ISSUE_TYPE_PROVIDER_SERVICE');

export interface IIssueTypeProviderService {
    getCurrentIssueType(): Observable<number>;
}

export const HISTORY_PROVIDER_SERVICE = new InjectionToken<IHistoryProviderService>('HISTORY_PROVIDER_SERVICE');

export interface IHistoryProviderService {
    changeProvider(oldValue: any, newValue: any): ChangeCollisionEntry[];
}

export const ISSUE_TRANSACTION_PROVIDER_SERVICE = new InjectionToken<IIssueTransactionProviderService>('ISSUE_TRANSACTION_PROVIDER_SERVICE');

export interface IIssueTransactionProviderService {
    issueTransaction$: Observable<IssueTransaction>; 
    issueTransactionDefaultMails$: Observable<DefaultMail[]>;
    issueTransactionAttributes$: Observable<number[]>;
    issueTransactionDefaultNotifications$: Observable<DefaultNotification[]>;
    setIssueTransaction(issueTransaction: IssueTransaction, attributes?: number[], defaultMails?: DefaultMail[], defaultNotifications?: DefaultNotification[]): void;
}

export const TRANSACTION_STEP_PROVIDER = new InjectionToken('ISSUE_TRANSACTION_STEP_PROVIDER');

export interface ITransactionProvider {
    steps$: Observable<Step[]>;
    executeTransaction(): Observable<Object>;

}

export const ISSUE_AUDIT_WRAPPER_PROVIDER = new InjectionToken('ISSUE_AUDIT_WRAPPER_PROVIDER');

export interface IIssueAuditWrapperProvider {
    issueAuditWrapper$: Observable<IssueAuditWrapper>;
    getIssueStatus(guid: string): Observable<IssueAuditStatus>;
    setIssueAuditWrapper(wrapper: IssueAuditWrapper);
}
